import { Analytics } from '@cobliteam/analytics';
import { Location } from '@cobliteam/common-types';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags/useFeatureFlags';
import Button from '@cobliteam/ui/components/Button';
import { useHistory } from 'react-router-dom';

const CTA_COLOR = '#0234E1';
const ICON_GRADIENT_ID = 'bannerLibAiIconGrad';

const JOURNEY_LOCATIONS: Record<string, string> = {
  'driver-registration': Location.DRIVER_MANAGEMENT,
  'vehicle-groups': Location.VEHICLES_GROUPS,
  installation: Location.ORDERS,
  checklists: Location.CHECKLIST_ALL,
  'fleet-policies': Location.ALERTS_TRIGGERS_CREATE,
  'locais-de-interesse': Location.GEOFENCES_CREATE,
};

interface UseAiRecommendationCtaOptions {
  component: string;
  journeyId: string;
  aiPrompt?: string;
  /** Label shown for the CTA. Defaults to 'Ir para a página'. */
  fallbackLabel?: string;
  /** Action called when the CTA is clicked. Defaults to navigating to the journey page. */
  fallbackAction?: () => void;
}

const AiIcon = ({ fill }: { fill?: string }) => (
  <svg width='22' height='22' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.8674 1.63092C14.1934 1.38362 14.5914 1.24976 15.0006 1.24976C15.4097 1.24976 15.8077 1.38362 16.1337 1.63092C16.4597 1.87822 16.6959 2.22538 16.8062 2.61944L16.8129 2.64438L18.789 10.3128C18.8448 10.5291 18.9576 10.7265 19.1155 10.8845C19.2734 11.0423 19.4707 11.155 19.6869 11.2109L27.3556 13.1871L27.3761 13.1926C27.7717 13.3017 28.1206 13.5376 28.3692 13.8641C28.6178 14.1906 28.7525 14.5897 28.7525 15.0001C28.7525 15.4105 28.6178 15.8095 28.3692 16.136C28.1206 16.4625 27.7717 16.6984 27.3761 16.8076L27.3556 16.813L19.6872 18.7892C19.4709 18.845 19.2735 18.9577 19.1155 19.1157C18.9576 19.2736 18.8448 19.471 18.789 19.6873L16.8116 27.3559L16.8049 27.3807C16.6946 27.7747 16.4585 28.1219 16.1325 28.3692C15.8065 28.6165 15.4085 28.7504 14.9993 28.7504C14.5901 28.7504 14.1921 28.6165 13.8661 28.3692C13.5401 28.1219 13.304 27.7748 13.1937 27.3807L13.187 27.3558L11.2108 19.6873C11.155 19.4711 11.0422 19.2736 10.8843 19.1157C10.7264 18.9577 10.529 18.845 10.3127 18.7892L2.64405 16.8117L2.61486 16.8038C2.22236 16.6924 1.8769 16.456 1.63091 16.1305C1.38492 15.805 1.25183 15.4081 1.25183 15.0001C1.25183 14.5921 1.38492 14.1952 1.63091 13.8696C1.8769 13.5441 2.22236 13.3077 2.61486 13.1963L2.64387 13.1885L10.3126 11.2097C10.5288 11.154 10.7264 11.0413 10.8844 10.8834C11.0422 10.7257 11.155 10.5285 11.2109 10.3125L13.1883 2.6442L13.1949 2.61944C13.3052 2.22539 13.5414 1.87822 13.8674 1.63092ZM15.0004 5.62906L16.3682 10.937C16.5356 11.5859 16.8739 12.1784 17.3478 12.6522C17.8216 13.1261 18.4138 13.4643 19.0627 13.6317L24.3726 15.0001L19.063 16.3684C18.4141 16.5358 17.8216 16.8741 17.3478 17.3479C16.8739 17.8218 16.5357 18.4139 16.3683 19.0628L14.9995 24.3711L13.6316 19.0631C13.4642 18.4142 13.1259 17.8218 12.6521 17.3479C12.1782 16.8741 11.5861 16.5358 10.9372 16.3684L5.62985 14.9999L10.937 13.6305C11.5856 13.4632 12.1777 13.1253 12.6515 12.6518C13.1253 12.1783 13.4637 11.5865 13.6314 10.938L15.0004 5.62906ZM25 2.50006C25.6904 2.50006 26.25 3.05971 26.25 3.75006V5.00006H27.5C28.1904 5.00006 28.75 5.55971 28.75 6.25006C28.75 6.94042 28.1904 7.50006 27.5 7.50006H26.25V8.75006C26.25 9.44042 25.6904 10.0001 25 10.0001C24.3096 10.0001 23.75 9.44042 23.75 8.75006V7.50006H22.5C21.8096 7.50006 21.25 6.94042 21.25 6.25006C21.25 5.55971 21.8096 5.00006 22.5 5.00006H23.75V3.75006C23.75 3.05971 24.3096 2.50006 25 2.50006ZM5 20.0001C5.69036 20.0001 6.25 20.5597 6.25 21.2501C6.94036 21.2501 7.5 21.8097 7.5 22.5001C7.5 23.1904 6.94036 23.7501 6.25 23.7501C6.25 24.4404 5.69036 25.0001 5 25.0001C4.30964 25.0001 3.75 24.4404 3.75 23.7501C3.05964 23.7501 2.5 23.1904 2.5 22.5001C2.5 21.8097 3.05964 21.2501 3.75 21.2501C3.75 20.5597 4.30964 20.0001 5 20.0001Z'
      fill={fill ?? `url(#${ICON_GRADIENT_ID})`}
    />
    {!fill && (
      <defs>
        <linearGradient id={ICON_GRADIENT_ID} x1='1.25183' y1='1.24976' x2='33.8555' y2='10.2361' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#001BB8' />
          <stop offset='1' stopColor='#9847EE' />
        </linearGradient>
      </defs>
    )}
  </svg>
);

const useAiRecommendationCta = ({ component, journeyId, aiPrompt, fallbackLabel, fallbackAction }: UseAiRecommendationCtaOptions) => {
  const history = useHistory();
  const { aiChat } = useFeatureFlags();

  const hasAgentAccess = aiChat;

  const onCta = () => {
    Analytics.track('Ai Recommendation call to action clicked', {
      component: component,
      journeyId: journeyId,
    });

    if (hasAgentAccess) {
      history.push(`${Location.AI}?prompt=${encodeURIComponent(aiPrompt ?? 'Como posso maximizar o valor da minha frota com a plataforma Cobli?')}`);
    } else if (fallbackAction) {
      fallbackAction();
    } else {
      const location = JOURNEY_LOCATIONS[journeyId];
      if (location) history.push(location);
    }
  };

  const ctaButton = hasAgentAccess ? (
    <button
      type='button'
      onClick={onCta}
      className='flex items-center gap-2 rounded-xl px-4 py-2 font-semibold text-sm text-white transition-opacity hover:opacity-90'
      style={{ background: CTA_COLOR }}
    >
      <AiIcon fill='white' />
      Ajuda com a Cobli AI
    </button>
  ) : (
    <Button variant='contained' color='primary' onClick={onCta}>
      {fallbackLabel ?? 'Ir para a página'}
    </Button>
  );

  return { ctaButton };
};

export default useAiRecommendationCta;
